import { Link, useSearch } from "@tanstack/react-router";
import { GitCompareArrowsIcon } from "lucide-react";
import { useState } from "react";
import { RolesTable } from "@/components/roles/RolesTable";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { originTarget, parseOriginSearch } from "@/lib/detail-origin";

export function RolesPage() {
  // If we arrived from a page like Org Health (the "Unfilled roles" tile), the
  // trail returns there instead of the catalog root. Frozen at mount — the
  // table rewrites this route's query string (filters) via replaceState.
  const search = useSearch({ strict: false });
  const [origin] = useState(() => originTarget(parseOriginSearch(search)));
  useSetBreadcrumbs(
    origin ? [origin, { label: "Roles" }] : [{ label: "Capability" }, { label: "Roles" }],
  );

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Capability"
        title="Roles"
        description="The catalog of roles that people can be assigned to. Status governs whether a role is assignable."
        actions={
          <Button asChild variant="outline">
            <Link to="/dashboard/roles/compare">
              <GitCompareArrowsIcon />
              Compare roles
            </Link>
          </Button>
        }
      />
      <RolesTable />
    </div>
  );
}
